services.service('ProChartService', ['config',
    function (config) {

        // var loader = ProChart_Loader();
        // var objChart;
        // var self = this;
        // var chartTheme = config['chartTheme'] || 'default';
        // initLoader({"layout": "layout-mobile", "template": chartTheme}, config.chartUrl);
        //
        // this.getLoader = function () {
        //     return loader;
        // };
        //
        // function noop() {
        // }
        //
        // function initLoader(config, rootpath) {
        //     loader.init.loadertemplates.push(config);
        //     loader.init.rootpath = rootpath;
        //     loader.combinemode = true;
        //     if (!self.loaded) preLoadChart();
        // }
        //
        // this.loaded = false;
        //
        //
        // function preLoadChart() {
        //     loader.LoaderInitComplete = eventLoaderComplete;
        //     loader.LoaderInitCombine();
        // }
        //
        // function eventLoaderComplete() {
        //     objChart = ProChart_InitLayout("#chartpreload", "layout-mobile", chartTheme);
        //     objChart.apiinit.rootpath = config.chartUrl;
        //
        //     objChart.events.layout.readyComplete = noop;
        //     objChart.gui.loadLayout();
        //     objChart.events.layout.initComplete = function() {
        //         objChart.chart.JSPush = {
        //             enableHistory: true,
        //             enableRT: true,
        //             enableSymbols: true,
        //             enableStudies: true,
        //             funcFetchData: noop
        //         };
        //         self.loaded = true;
        //     };
        //     objChart.events.chart.createComplete = noop;
        // }

        return this;
    }
]);
